import React from "react"
import {FieldTableCellProps, FieldTableCellState, getTableCellStyle} from "../../../../render/table/table-cell";
import {LifecycleAction} from "../../../../../gd/const/lifecycle";
import FieldReaction_TableCellValue from "./value";
import FieldReaction from "../../reaction";
import {isBulkSelection} from "../../../../../gd/right-click-menu";
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"
import TasksViewManager from "../../../../../gd-modules/tasks-view/core/manager"


// const debug = "FieldReaction_TableCell"
const debug = false


export default class FieldReaction_TableCell extends React.Component<FieldTableCellProps, FieldTableCellState> {

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered   : false,
            showPopover : false
        }
    }

    get canEdit():boolean {
        if (this.props.manager.isReadOnly) return false
        return this.props.field.canEdit(this.props.listItem.item)
    }

    onMouseEnter = () => {
        if (!this.canEdit) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {

        if (this.state.showPopover) return //

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    onValueChange = (value:any, hidePopover:boolean=true) => {

        hidePopover && this.hidePopover()

        // if field has tableCellOnValueChange - use it !!!
        if (this.props.field.fieldParams.tableCellOnValueChange) {
            this.props.field.fieldParams.tableCellOnValueChange(this.props.listItem, value, this.props.manager)
            return
        }

        // Otherwise default = custom field

        this.props.listItem.item.setCustomFieldValue(this.props.field.fieldId, value)
        this.props.listItem.item.save()

        this.props.listItem.updateLastUpdateTime() // otherwise it wont re-render
        FieldProto_updateView(this.props.manager as TasksViewManager, this.props.field)
    }

    // onResetValueClick = (e:React.SyntheticEvent) => {
    //     e.stopPropagation()
    //     this.onValueChange(null, false)
    // }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.canEdit) return

        this.setState({
            showPopover     : !this.state.showPopover
        })
    }
    //
    // onOptionClick = (option:Option) => {
    //     this.onValueChange(option.value)
    // }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }


    // OPTIONS
    onOptionClick = (option:Option, e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        const field     = this.props.field as unknown as FieldReaction
        const model     = this.props.listItem.item


        const newValue  = field.toggleValue(model, option.value)
        this.onValueChange(newValue, false)
    }

    onDeleteOption = (option:Option, e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        const field     = this.props.field as unknown as FieldReaction
        const model     = this.props.listItem.item

        const newValue  = field.removeValue(model, option.value)
        this.onValueChange(newValue, false)
    }


    renderHovered() {

        const field = this.props.field as unknown as FieldReaction

        const classes = Classes("cell-flex ui5-txt-less-important-small", this.props.column.id, {
            'is-hovered'        : this.state.isHovered
        })

        return (
            <React.Fragment>
                <div className={classes} style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={this.onClick}>
                    <div className="ui5-field-editable is-hovered size-small w-100-percent h-100-percent">

                        <div className="flex-row-left-center min-w-0 w-100-percent">

                            <FieldReaction_TableCellValue model          = {this.props.listItem.item}
                                                          field          = {this.props.field as unknown as FieldReaction}
                                                          columnWidth    = {this.props.column.width}
                                                          isHovered      = {this.state.isHovered}
                                                          onValueChange  = {this.onValueChange}/>
                        </div>


                        <div className="buttons">
                            {/*{!field.isEmpty(this.props.listItem.item) &&*/}
                            {/*    <div className="btn-reset" onClick={this.onResetValueClick}/>*/}
                            {/*}*/}
                            <div className="btn-arrow"/>
                        </div>

                    </div>

                    {this.state.showPopover &&
                        <field.components.PopoverMenu parent={this} field={this.props.field} model={this.props.listItem.item} />
                    }

                </div>
            </React.Fragment>
        )
    }

    renderNotHovered() {
        const classes = Classes("cell-flex ui5-field-editable size-small")

        return (
            <React.Fragment>
                <div className={classes} style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                    <FieldReaction_TableCellValue model          = {this.props.listItem.item}
                                                  field          = {this.props.field as unknown as FieldReaction}
                                                  columnWidth    = {this.props.column.width}
                                                  onValueChange  = {this.onValueChange}
                    />
                </div>
            </React.Fragment>
        )

    }

    render() {
        if (this.state.isHovered) return this.renderHovered()
        else return this.renderNotHovered()
    }

}



